import { DirectionalHint, IDropdownOption } from '@fluentui/react';
import React, { Component } from 'react';
import { SearchComponent } from '../../../src/dashboard/SearchComponent';
import { SearchableDD } from './SearchableDD';
import { getSelectableDropdownOptions, normalizeDropdownOption } from './DropdownOptionUtils';

export interface CustomDropdownProps {
  selectedItems?: string[];
  dropdownOptions: IDropdownOption[];
  placeholder: string;
  label?: string;
  disabled?: boolean;
  searchable?: boolean;
  individualItem?: boolean;
  canSelectAll?: boolean;
  onChangeCallBack: (item: any) => void;
  onBlurCallback?: (item: any) => void;
  selectedItem?: any;
  multiSelect?: boolean;
  title?: string;
  preSearch?: boolean;
  id?: string;
  showLogicalRadioButton?: boolean;
  onLogicalRadioButtonChangeCallBack?: Function;
  disableSort?: boolean;
  styleSearchClass?: boolean;
  manageActionStyle?: boolean;
  clickLabel?: string;
  onSearchChange?: (searchText: string) => void;
  separator?: string;
  tooltipDirectionalHint?: DirectionalHint;
  clearable?: boolean;
  onClear?: () => void;
  resolvingOptions?: boolean;
}

//This component chooses which drop down to populate based on the multiselect property.

export class CustomDropdown extends Component<CustomDropdownProps> {
  render() {
    const multiSelectOptions = getSelectableDropdownOptions(
      this.props.dropdownOptions,
      this.props.placeholder
    );

    return this.props.multiSelect ? (
      <SearchComponent
        selectedItems={this.props.selectedItems ? this.props.selectedItems : []}
        dropdownOptions={multiSelectOptions}
        placeholder={this.props.placeholder}
        label={this.props.label}
        disabled={this.props.disabled}
        searchable={this.props.searchable}
        individualItem={this.props.individualItem}
        canSelectAll={this.props.canSelectAll}
        onChangeCallBack={this.props.onChangeCallBack}
        onBlurCallback={this.props.onBlurCallback}
        preSearch={this.props.preSearch}
        showLogicalRadioButton={this.props.showLogicalRadioButton}
        onLogicalRadioButtonChangeCallBack={this.props.onLogicalRadioButtonChangeCallBack}
        id={this.props.id}
        disableSort={this.props.disableSort}
        styleSearchClass={this.props.styleSearchClass}
        manageActionStyle={this.props.manageActionStyle}
        clickLabel={this.props.clickLabel}
        onSearchChange={this.props.onSearchChange}
        separator={this.props.separator}
        resolvingOptions={this.props.resolvingOptions}
      />
    ) : (
      <SearchableDD
        placeholder={this.props.placeholder}
        label={this.props.label}
        dropdownOptions={this.props.dropdownOptions}
        selectedItem={
          this.props.label === 'filterByRequestType'
            ? this.props.selectedItem
            : this.props.selectedItem
              ? this.props.selectedItem
              : ''
        }
        onChangeCallBack={(option) => {
          const normalizedOption = normalizeDropdownOption(option, this.props.placeholder);
          if (normalizedOption) {
            this.props.onChangeCallBack(normalizedOption);
          }
        }}
        disabled={this.props.disabled}
        onSearchChange={this.props.onSearchChange}
        tooltipDirectionalHint={this.props.tooltipDirectionalHint}
        clearable={this.props.clearable}
        onClear={this.props.onClear}
      />
    );
  }
}
// Generated by GitHub Copilot | Updated on: 2026-08-11 | 14 lines modified | Filtered placeholder dropdown options
// Generated by GitHub Copilot | Updated on: 2026-08-14 | 8 lines modified | Restore single-select placeholder clearing
